export default __webpack_public_path__ + "static/media/cluster_point_blue.3a6517b4.svg";